export const INITIAL_POSITIONS = [
  ["-lion", "", "", "", "", "", "-tiger"],
  ["", "-dog", "", "", "", "-cat", ""],
  ["-rat", "", "-leopard", "", "-wolf", "", "-elephant"],
  ["", "", "", "", "", "", ""],
  ["", "", "", "", "", "", ""],
  ["", "", "", "", "", "", ""],
  ["elephant", "", "wolf", "", "leopard", "", "rat"],
  ["", "cat", "", "", "", "dog", ""],
  ["tiger", "", "", "", "", "", "lion"]
];

export const TERRAIN = [
  ["space", "space", "trap", "-den", "trap", "space", "space"],
  ["space", "space", "space", "trap", "space", "space", "space"],
  ["space", "riverside", "riverside", "space", "riverside", "riverside", "space"],
  ["riverside", "river", "river", "riverside", "river", "river", "riverside"],
  ["riverside", "river", "river", "riverside", "river", "river", "riverside"],
  ["riverside", "river", "river", "riverside", "river", "river", "riverside"],
  ["space", "riverside", "riverside", "space", "riverside", "riverside", "space"],
  ["space", "space", "space", "trap", "space", "space", "space"],
  ["space", "space", "trap", "den", "trap", "space", "space"]
];

export const COLORS = {
  logo: "#e38542",
  red: "#ad1203",
  blue:"#0b5e99",
  dark: "#353535"
};